import { connect } from 'react-redux'
import * as processSelector from '../../../process/state/instance-detail/selector'
import VoucherWidget from './VoucherWidget'


const mapStateToProps = (state, props) => {
    return {
        voucherList: processSelector.selectProcessVoucherList(state),
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(VoucherWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/VoucherWidgetContainer.js